import { useEffect, useState } from 'react'
import SBheader from '../../components/SBheader'
import SBnewFooter from '../../components/SBnewFooter'
import { getStandardCmsPage } from '../../helpers/rioHelper'
import { RichTextRenderer } from "@webiny/react-rich-text-renderer"

export default function Community() {

  const [cmsContent,setCmsContent] = useState([])
  const [pageTitle,setPageTitle] = useState([])

  useEffect(async () => {
    let resp = await getStandardCmsPage("delivery-getir")
    setPageTitle(resp.data.result.pageTitle)
    let richContent = resp.data.result
    setCmsContent(richContent.blocks)
  }, [])

  function communityRenderer(block) {
    return(
      <>
         {block.richContent && <RichTextRenderer data={block.richContent}/>}
         {block.button.map((b,i) => (
            <>
             {b.text && <button className="sb-button sb-button--positive" style={{marginTop:"20px",display:"block"}} onClick={()=>{window.open(b.link)}}>{b.text}</button>} 
            </>
          ))
         }
      </>)
  }

  return (
    <div>
      <div>

        <SBheader />

        <main style={{ marginBottom: 30 }} className="sb-community height-100 flex flex-column">

          <div className="sb-headerCrate flex flex-column bg-white  flex-shrink-none">
            <div className="flex flex-grow flex-column ">
              <div className="container--headerCrate sb-headerCrate--content size12of12 ">
                <h1 className="sb-heading sb-heading--large text-bold" style={{ lineHeight: "36px" }} tabIndex={-1}>{pageTitle}</h1></div>
            </div>
          </div>

          <div style={{ backgroundColor: "#f7f7f7", marginBottom: 30 }} className="sb-contentCrate flex-grow ">
            <div className="relative flex-auto">
              <div className="flex-auto">
                  <div className='pt3 px3 lg-px0 content___LdxU3'>
                      {cmsContent.map((b,i)=>(
                        <div className="community-content" key={i}>
                          {communityRenderer(b)}
                        </div>
                      ))}
                  </div>
              </div>
            </div>
            <div style={{ paddingTop: "50px" }}></div>
            <SBnewFooter />
          </div>

        </main>
      </div >
    </div >
  )
}